import { NgModule } from 'ng-metadata/core';
import {FacetService} from './facet.service';
import {PrmFacetExact} from './facetExact/facetExact.directive';
import {PrmFacetRange} from './facetRange/facetRange.directive';
import {PrmFacetGroup} from './facetGroup.directive';
import {PrmFacet} from './facet.directive';
import {PrmBreadcrumbs} from '../breadcrumbs/breadcrumbs.directive';
import {FacetTransformationModule} from "./facetsTransformation/facetTransformation.module";
import { PrmOrganizationOrFacetToggle } from '../../journals/organizationOrFacetToggle/organization-or-facet-toggle.directive';
import { OrganizationOrFacetToggleService } from '../../journals/organizationOrFacetToggle/organization-or-facet-toggle.service';

@NgModule({
    declarations: [
        PrmBreadcrumbs,
        PrmFacet,
        PrmFacetExact,
        PrmFacetGroup,
        PrmFacetRange,
        PrmOrganizationOrFacetToggle,

    ],
    providers: [
        FacetService,
        OrganizationOrFacetToggleService,

    ],
    imports:[
        FacetTransformationModule
    ]
})
export class FacetModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facet.module.ts